import { Injectable, inject } from '@angular/core';
import {
  DvCheckboxElement,
  DvDropdownGridElement,
  DvTextboxElement,
} from '@devinco/ui/legacy';
import { ColumnType } from '@features/vt-grid/grid-options/column-types';
import { DropdownGridOptionsService } from '@features/vt-grid/grid-options/dropdown-grid-options.service';
import { TranslateService } from '@ngx-translate/core';
import { Entity } from '@shared/constants/entity';

@Injectable()
export class VehicleSetupTabService {
  private gridOptionsService = inject(DropdownGridOptionsService);
  private translate = inject(TranslateService);

  departmentElements = [
    new DvCheckboxElement({
      key: 'TripDepartmentFromUser',
      checkboxLabel: 'VehicleTypeSetup.TripDepartmentFromUser',
      infoIconText: 'VehicleTypeSetup.TripDepartmentFromUserInfoText',
      colspan: 12,
    }),
  ];

  purposeElements = [
    new DvTextboxElement({
      colspan: 12,
      key: 'Purpose',
      label: 'Vehicle.DefaultPurpose',
      infoIconText: 'VehicleTripSetup.PurposeTooltip',
    }),
    new DvCheckboxElement({
      colspan: 12,
      key: 'RequirePurposeOnTripTypeChange',
      checkboxLabel: 'VehicleTripSetup.RequirePurposeOnTripTypeChange',
      infoIconText: 'VehicleTripSetup.RequirePurposeOnTripTypeChangeTooltip',
    }),
  ];

  privateTaxableElements = [
    new DvCheckboxElement({
      colspan: 12,
      key: 'PrivateTaxableNotAllowed',
      checkboxLabel: 'VehicleTypeSetup.PrivateTaxableNotAllowed',
      infoIconText: 'VehicleTypeSetup.PrivateTaxableNotAllowed.Info',
    }),
    new DvCheckboxElement({
      colspan: 12,
      key: 'PrivateOccasionalNotAllowed',
      checkboxLabel: 'VehicleTypeSetup.PrivateOccasionalNotAllowed',
      infoIconText: 'VehicleTypeSetup.PrivateOccasionalNotAllowed.Info',
    }),
  ];

  tripPositionElements = [
    new DvCheckboxElement({
      key: 'AllowTripTrackingDetail',
      checkboxLabel: 'VehicleTypeSetup.AllowTripTrackingDetail',
      infoIconText: 'VehicleTypeSetup.AllowTripTrackingDetail.Info',
    }),
  ];

  ferryDiscountElements = [
    new DvDropdownGridElement({
      key: 'FerryDeals',
      valueField: 'FerryDealID',
      labelFields: ['Name'],
      colspan: 12,
      enableColumnHeaders: true,
      gridOptions: {
        ...this.gridOptionsService.clientSideMultiSelect(
          Entity.FerryDeal,
          [
            { field: 'FerryDealID', type: ColumnType.Id, hide: true },
            {
              field: 'Name',
              type: ColumnType.Text,
              headerName: 'VehicleSetup.FerryDealName',
            },
            {
              field: 'Description',
              type: ColumnType.Text,
              headerName: 'VehicleSetup.FerryDealDescription',
            },
            {
              field: 'Provider',
              type: ColumnType.Text,
              headerName: 'VehicleSetup.FerryDealProvider',
            },
          ].map(colDef => ({
            ...colDef,
            headerName: colDef.headerName
              ? this.translate.instant(colDef.headerName)
              : '',
          }))
        ),
        getRowId: ({ data }) => data.FerryDealID,
      },
    }),
  ];
}
